// extracted by mini-css-extract-plugin
export default {"modal-container":"ChatbotRoomModal__modal-container__rqOGd","modalContainer":"ChatbotRoomModal__modal-container__rqOGd","iframe":"ChatbotRoomModal__iframe__kttKm"};